var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"dense":_vm.dense,"type":"text","label":_vm.label,"rules":[_vm.onlyNumber, ..._vm.rules],"value":_vm.value,"autocomplete":_vm.autocomplete,"suffix":_vm.suffix,"outlined":_vm.outlined,"prepend-inner-icon":_vm.prependInnerIcon,"disabled":_vm.disabled},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }